export const serverToClientMessages = {
  connectionIdMessage: 'ConnectionIdMessage',
  applicationInfoUpdate: 'ApplicationInfoUpdate',
  platformInstanceHub: {
    deviceFrontEndAfmelden: 'DeviceFrontEndAfmelden',
    forceFrontEndAfmelden: 'ForceFrontEndAfmelden',
    updateClients: 'UpdateClients',
    applicationInfoUpdate: 'ApplicationInfoUpdate',
    chartsChanged: 'ChartsChanged',
    platformModeChanged: 'PlatformModeChanged',
    lineTextReviewChanged: 'LineTextReviewChanged'
  },
  presentUsersHub: {
    presentDeviceUsersChanged: 'PresentDeviceUsersChanged',
    frontEndUpdatePresentUsers: 'FrontEndUpdatePresentUsers'
  }
};
